module.exports = __webpack_public_path__ + "static/media/work-2.097663bd.jpg";